// extracted by mini-css-extract-plugin
export default {"signupButton":"signupbutton_signupButton__s+kx3"};